import { render } from "./TheSidebar.vue?vue&type=template&id=5e9947b9&scoped=true&ts=true"
import script from "./TheSidebar.vue?vue&type=script&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&lang=ts"

import "./TheSidebar.vue?vue&type=style&index=0&id=5e9947b9&scoped=true&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9947b9"]])

export default __exports__